import umi from "./assets/umi.jpg";

export function AboutUs()
{
    const spanColor = "#EB6E48";
    const p1 = <>We are Lonely House, a team of game developers from Chile that want to create short and high quality horror experiences anyone can enjoy.</>;
    const p2 = <>Our games are about putting cute characters in familiar yet unsettling worlds that beckon you to explore the unknown.</>;
    const p3 = <>Our promise is to provide a horror game experience that does not rely on jump scares or brutal gore to be scary, and instead is memorable through the tense atmosphere, off-kilter storytelling and that nagging feeling that there's something just a little bit out of place.</>;

    return (
        <div className="flex flex-col justify-center items-center mt-8 md:mt-16 lg:mt-24">
            <h3 className="AboutUsTitle text-center text-3xl md:text-6xl font-bold">
                About Us
            </h3>

            <div className="flex flex-col lg:flex-row xl:flex-row 2xl:flex-row justify-center items-center">
                <div className="w-4/5 sm:w-1/2 lg:w-1/4">
                    <img src={umi}  alt="Umi"/>
                </div>
                <div className="lg:pl-12 flex justify-center align-middle h-full pt-4 lg:pt-0">
                    <div className="flex flex-col w-full items-end">
                        <p className="aboutus-paragraph pt-10 text-sm md:text-xl lg:text-base 2xl:text-xl">{p1}</p>
                        <p className="aboutus-paragraph pt-10 text-sm md:text-xl lg:text-base 2xl:text-xl">{p2}</p>
                        <p className="aboutus-paragraph pt-10 text-sm md:text-xl lg:text-base 2xl:text-xl">{p3}</p>
                    </div>
                </div>
            </div>
        </div>
    )
}